import React from "react";

import PageLayout from "Components/PageLayout";
import NavBar from "Containers/NavBar";
import { organizationByDescriptionIdSelector } from "Reducers/organization/organization";
import { useAppSelector } from "Store/hooks";

import OrganizationPaymentFailed from "./containers/OrganizationPaymentFailed";
import Page from "./Page";

type Props = {
  organizationName: string;
};

const Routes = (props: Props) => {
  const organization = useAppSelector(state =>
    organizationByDescriptionIdSelector(state, {
      organizationDescriptionId: props.organizationName
    })
  );

  return (
    <>
      <OrganizationPaymentFailed />
      <NavBar organizationId={props.organizationName} />
      <PageLayout className="project">
        {organization && <Page organization={organization} />}
      </PageLayout>
    </>
  );
};

export default Routes;
